import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { formatDate } from '../../../../utilityFunctions';
export const SuccessfulMessage = (props) => {
    const { message } = props
    return (
        <div className="successfulDialogWrap">
            <div className="icons">
                <CheckCircleIcon sx={{ width: '38px', height: '38px', color: '#3C763C' }} />
                <div className='successfulHeader'>Success !</div>
            </div>
            <div className="message">
                {message}
            </div>
        </div>)
}


export const psgCurrentBkgColDef = [
    { headerName: 'Name', field: '', headerSx: { textAlign: 'left', width: "418px" }, },
    { headerName: 'Gender', field: '', headerSx: { textAlign: 'left', width: "177px" }, },
    { headerName: 'Age', field: '', headerSx: { textAlign: 'left', width: "177px" }, },
    { headerName: 'Concession', field: '', headerSx: { textAlign: 'left', width: "177px" }, },
    { headerName: 'Nationality', field: '', headerSx: { textAlign: 'left', width: "177px" }, },
    { headerName: 'Basic Fare', field: '', headerSx: { textAlign: 'right', width: "177px" }, },
]
export const passengerSectionTotal = [
    { name: 'Reservation Fee (+)', field: 'reservation' },
    { name: 'Concessions (-)', field: 'concessions' },
    { name: 'ARF+UF-TF+EF+BF (+)', field: 'levies' },
    { name: 'GST (+)', field: 'gst' },
    { name: 'Total Fare', field: 'totalFare' },
    { name: 'Balance Amount', field: 'totalFare' },
]

export const ticketColumnDef = [
    { headerName: 'Trip\nCode', field: '', headerSx: { textAlign: 'left', width: "98px" }, },
    { headerName: 'Depot\nName', field: '', headerSx: { textAlign: 'left', width: "148px" }, },
    { headerName: 'Via\nPlace', field: '', headerSx: { textAlign: 'left', width: "300px" }, },
    { headerName: 'Distance\n(Kms)', field: '', headerSx: { textAlign: 'left', width: "77px" }, },
    { headerName: 'Departure\nTime', field: '', headerSx: { textAlign: 'left', width: "58px" }, },
    { headerName: 'Arrival\nTime', field: '', headerSx: { textAlign: 'left', width: "80px" }, },
    { headerName: 'Adult Fare\n(Incl.Levies)', field: '', headerSx: { textAlign: 'right', width: "145px" }, },
    { headerName: 'Child\nFare', field: '', headerSx: { textAlign: 'right', width: "58px" }, },
    { headerName: 'Type', field: '', headerSx: { textAlign: 'left', width: "54px" }, },
    { headerName: 'Seats', field: '', headerSx: { textAlign: 'left', width: "51px" }, },
    { headerName: 'Trip Sheet\nCut-Off Time', field: '', headerSx: { textAlign: 'left', width: "95px" }, },
    { headerName: 'Action', field: '', headerSx: { textAlign: 'left', width: "81px" }, },
]
export const ticketColumnDefAdmin = [
    { headerName: 'Trip\nCode', field: '', headerSx: { textAlign: 'left', width: "98px" }, },
    { headerName: 'Depot\nName', field: '', headerSx: { textAlign: 'left', minWidth: "148px" }, },
    { headerName: 'Via\nPlace', field: '', headerSx: { textAlign: 'left', minWidth: "180px" }, },
    { headerName: 'Distance\n(Kms)', field: '', headerSx: { textAlign: 'left', width: "77px" }, },
    { headerName: 'Departure\nTime', field: '', headerSx: { textAlign: 'left', width: "65px" }, },
    { headerName: 'Arrival\nTime', field: '', headerSx: { textAlign: 'left', width: "60px" }, },
    { headerName: 'Adult Fare/Adult Fare\n(Incl.Levies)', field: '', headerSx: { textAlign: 'right', minWidth: "160px", maxWidth: '160px' }, },
    { headerName: 'Child Fare/Child Fare(Incl.Levies)', field: '', headerSx: { textAlign: 'right', minWidth: "140px", maxWidth: '140px' }, },
    { headerName: 'Type', field: '', headerSx: { textAlign: 'left', width: "54px" }, },
    { headerName: 'Seats', field: '', headerSx: { textAlign: 'left', width: "51px" }, },
    { headerName: 'Trip Sheet\nCut-Off Time', field: '', headerSx: { textAlign: 'left', minWidth: "100px", maxWidth: '100px' }, },
    { headerName: 'Action', field: '', headerSx: { textAlign: 'left', width: "81px" }, },
]

export const paymentModaList = [
    { id: 0, name: "Cash" },
    { id: 1, name: "Credit/Debit" },
    { id: 2, name: "Net Banking" },
    { id: 3, name: "UPI" },
]
export const upiAppList = [
    { id: 0, name: "PAYTM UPI" },
    { id: 1, name: "GOOGLE PAY" },
    { id: 2, name: "PHONE PAY" },
]

export const QuotaTypeOpt = [
    { id: 1, name: 'CREW' },
    { id: 2, name: 'ENROUTE QUOTA' },
    { id: 3, name: 'EXMLA' },
    { id: 4, name: 'EXMLC' },
    { id: 5, name: 'LADIES SEATS' },
    { id: 6, name: 'MLA' },
    { id: 7, name: 'MLC' },
    { id: 8, name: 'OTHERS' },
    { id: 9, name: 'PERMANENT BLOCKING' },
    { id: 10, name: 'SPLIT SERVICE QUOTA' },
    { id: 11, name: 'TC QUOTA' },
]
export const blockTypeOpt = [
    { id: "P", name: 'SPECIAL BLOCKING' }
]
export const blockSeatDetailsObj = {
    mobileNo: '',
    emailID: '',
    passengeConcession: [],
    refId: "",
    sendSMS: 1,
    droppingPoint: [],
    boardingPoint: [],
    selectSeatList: [],
    totalFare: 0,
    blockType: [blockTypeOpt[0]],
    QuotaType: []
}

export const onwardBlockSeat = {
    mobileNo: '',
    emailID: '',
    passengeConcession: [],
    refId: "",
    droppingPoint: [],
    boardingPoint: [],
    selectSeatList: [],
    totalFare: 0,
    FromCityID: 0,
    ToCityID: 0,
    JourneyDate: '',
    TripID: 0,
    SeaterLow: 0,
    SeaterHigh: 0,
    SlumberLow: 0,
    SlumberHigh: 0,
    SleeperLow: 0,
    SleeperHigh: 0,
    ChartDate: '',
    blockType: [],
    QuotaType: [],
    selConcession: [],
    selectseat: [],
    ArrivalTimeActual: formatDate(window.getTime ? window.getTime() : new Date()),
    roundOff: 0,
    disCount: 0
}

export const seatBlockCombine = (value, pasName, concessionType) => {
    if (value) {
        return `1~${value?.SeatNo}~${pasName}~${value?.Gender}~${value?.age}~${value?.fare}~~~~~0~0~${value?.bfAmt}~${value?.efAmt}~${value?.InfraFee}~${value?.arfAmt}~${value?.seatRes}~${value?.tfAmt}~${value?.ufAmt}~${concessionType?.[0]?.ConcessionTypeID || 0}~${value?.seatCon}~${concessionType?.[0]?.ConcessionID || 0}~~~~~${value?.seatDis}`
    } else {
        return `1~~~M~0~0~~~~~0~0~0~0~0~0~0~0~0~0~0~0~~~~~`
    }
}

export const getPassengerDetailFromSeatSelection = (arr, levies, conncession, discountCalculator = [], gstCalculator = [], roundOff = [], isRetdiscount = false, returnDiscountFlag = 0, flexiDiscount = [],) => {
    let newData = []
    let reservation = 0
    let concessions = 0
    let leviesAmt = 0
    let gst = 0
    let disCount = 0
    let roundoffValue = 0
    let totalFare = 0
    arr.map((val) => {
        let seatRes = 0
        let seatCon = 0
        let seatGst = 0
        let arfAmt = 0
        let ufAmt = 0
        let tfAmt = 0
        let efAmt = 0
        let bfAmt = 0
        let InfraFee = 0
        let gstPre = 0
        let IsPercentageGST = false
        let seatDis = 0
        let baseFare = val?.baseFare
        let isReturnDiscountFlag = returnDiscountFlag ? 10 : 0
        if (conncession.length > 0) {
            if ((discountCalculator?.length > 0 && arr.length >= discountCalculator?.[0]?.MinSeat) && (conncession[0]?.ConcessionPer < (isRetdiscount ? discountCalculator?.[0]?.ReturnPtc : discountCalculator?.[0]?.OnwardPtc))) {
                if (isRetdiscount) {
                    if (discountCalculator?.[0]?.ReturnPtc >= isReturnDiscountFlag) {
                        disCount += Math.floor((val?.baseFare * discountCalculator?.[0]?.ReturnPtc) / 100)
                        seatDis += Math.floor((val?.baseFare * discountCalculator?.[0]?.ReturnPtc) / 100)
                    } else {
                        disCount += Math.floor((val?.baseFare * isReturnDiscountFlag) / 100)
                        seatDis += Math.floor((val?.baseFare * isReturnDiscountFlag) / 100)
                    }
                } else {
                    if (!((flexiDiscount?.length > 0 && flexiDiscount?.[0]?.IsGroupDiscountFlexiFare === 1) && arr?.length >= flexiDiscount?.[0]?.FlexiDiscountPaxCount)) {
                        disCount += Math.floor((val?.baseFare * discountCalculator?.[0]?.OnwardPtc) / 100)
                        seatDis += Math.floor((val?.baseFare * discountCalculator?.[0]?.OnwardPtc) / 100)
                    }
                }
            } else {
                if (isRetdiscount && conncession[0]?.ConcessionPer < isReturnDiscountFlag) {
                    disCount += Math.floor((val?.baseFare * isReturnDiscountFlag) / 100)
                    seatDis += Math.floor((val?.baseFare * isReturnDiscountFlag) / 100)
                } else {
                    let preConcession = (val?.baseFare * conncession[0]?.ConcessionPer) / 100
                    if (conncession[0]?.RoundOff === 1) {
                        let amount = Math.floor(preConcession)
                        concessions += amount
                        seatCon = amount
                    }
                    if (conncession[0]?.RoundOff === 2) {
                        let amount = Math.ceil(preConcession)
                        concessions += amount
                        seatCon = amount
                    }
                    if (conncession[0]?.RoundOff === 3) {
                        let amount = Math.round(preConcession)
                        concessions += amount
                        seatCon = amount
                    }
                }
            }
        }
        levies.map((obj) => {
            let amount = 0
            let concessionLevies = conncession?.[0]?.CorporationLavyIDs?.split(",")
            if ((obj?.MinBaseFare <= val?.baseFare && obj?.MaxBaseFare >= val?.baseFare) && concessionLevies.includes(obj.CorporationLevyID?.toString())) {
                if (obj?.IsPercentage === 1) {
                    if (obj?.LevyID === 3) {
                        IsPercentageGST = true
                        gstPre += obj?.AdultAmount
                    } else {
                        amount = (val?.baseFare * obj?.AdultAmount) / 100
                    }
                } else {
                    if (obj?.LevyID === 3) {
                        IsPercentageGST = false
                        gstPre += obj?.AdultAmount
                    } else {
                        amount = obj?.AdultAmount
                    }
                }
                if (obj.LevyID === 6) {
                    reservation += amount
                    seatRes += amount
                } else if ([5, 8, 2, 4, 1, 7].includes(obj?.LevyID)) {
                    leviesAmt += amount
                    if (obj?.LevyID === 5) {
                        arfAmt += amount
                    } else if (obj?.LevyID === 8) {
                        ufAmt += amount
                    } else if (obj?.LevyID === 2) {
                        efAmt += amount
                    } else if (obj?.LevyID === 1) {
                        bfAmt += amount
                    } else if (obj?.LevyID === 7) {
                        tfAmt += amount
                    } else if (obj?.LevyID === 4) {
                        InfraFee += amount
                    }
                }

            }
        })
        let gstAmount = gstPre === 0 ? 0 : IsPercentageGST ? ((Number(val?.baseFare) + seatRes - seatCon - seatDis + arfAmt + ufAmt + tfAmt + efAmt + bfAmt + InfraFee) * gstPre) / 100 : (Number(val?.baseFare) + seatRes - seatCon - seatDis + arfAmt + ufAmt + tfAmt + efAmt + bfAmt + InfraFee + gstPre)
        if (gstAmount !== 0) {
            if (gstCalculator.length === 0) {
                gst += Math.ceil(gstAmount)
                seatGst += Math.ceil(gstAmount)
            } else if (gstCalculator?.length !== 0) {
                gst += Math.ceil(gstAmount / 2) * 2
                seatGst += Math.ceil(gstAmount / 2) * 2
            } else {
                gst += Math.ceil(gstAmount)
                seatGst += Math.ceil(gstAmount)
            }
        }
        newData.push({
            SeatNo: val?.SeatLabel,
            Gender: val?.Gender.trim() !== '' ? val?.Gender : 'M',
            age: 21,
            fare: val?.baseFare,
            seatRes, seatCon, seatGst, arfAmt, ufAmt, tfAmt, efAmt, bfAmt, InfraFee, seatDis
        })
        totalFare += val?.baseFare
    })
    if (roundOff.length > 0 && roundOff?.[0]?.RoundTotal10 === 1) {
        roundoffValue = Math.round(Number(reservation - concessions - disCount + leviesAmt + gst + totalFare) / 10) * 10
    }
    let roundOffAmt = roundoffValue === 0 ? 0 : roundoffValue - Number(reservation - concessions - disCount + leviesAmt + gst + totalFare)
    return { seatData: newData, totalFare, disCount, roundOffAmt }
}



export function blockGenderCount(obj) {
    return obj.reduce((acc, curVal) => {
        if (curVal.Gender === 'F') {
            acc.female++;
        }
        else {
            acc.male++;
        }
        return acc;
    }, { male: 0, female: 0 });
}
export function blockGenderCountSelSeat(obj) {
    return obj.reduce((acc, curVal) => {
        if (curVal.Gender === 'F') {
            acc.female++;
        }
        else {
            acc.male++;
        }
        return acc;
    }, { male: 0, female: 0 });
}